import { Box, Grid, TextField, Typography } from "@mui/material";
import { H3 } from "app/components/Typography";
import React, { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { LoadingButton } from "@mui/lab";
import SnackbarProvider from "app/components/SnackbarProvider";
import {
  AccountBalanceOutlined,
  ArrowRightAltOutlined,
} from "@mui/icons-material";
import { requestInstitution } from "app/services/institutionServices/Institution";
import { notify } from "app/utils/notifyUtils";

const style = {
  position: "absolute" as "absolute",
  top: "20%",
  left: "50%",
  transform: "translate(-50%, -20%)",
  width: "30%",
  bgcolor: "background.paper",
  border: "1px solid #CCC",
  borderRadius: "5px",
  boxShadow: 24,
  p: 4,
};

const validationSchema = Yup.object().shape({
  code: Yup.string().required("Sigla é um campo obrigatório"),
  institution: Yup.string().required("Instituição é obrigatório"),
  unit: Yup.string().required("Cidade é obrigatório"),
  department: Yup.string().required("Unidade é obrigatório"),
});

interface FormValues {
  code: string;
  institution: string;
  unit: string;
  department: string;
}

interface ComponentProps {
  handleClose: any;
  institution?: string;
  division?: string;
  data: any;
}

const FormInstitutionRequest: React.FC<ComponentProps> = ({
  handleClose,
  institution = "",
  division = "",
  data,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const snackbarProvider = SnackbarProvider();

  const handleFormSubmit = async (values: FormValues) => {
    setLoading(true);
    const data = {
      code: values.code,
      institutionId: institution,
      institution: values.institution,
      divisionId: division,
      division: values.unit,
      department: values.department,
    };

    try {
      await requestInstitution(data);
      handleClose("success", "Dados enviados com sucesso!");
    } catch (error) {
      notify("error", "Erro ao enviar dados. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const initialValues = {
    code: data?.find((item) => item?.id === institution)?.code || "",
    institution: data?.find((item) => item?.id === institution)?.name || "",
    unit:
      data
        ?.find((item) => item?.id === institution)
        ?.divisions.find((item) => item.id === division)?.name || "",
    department: "",
  };

  return (
    <div>
      <Box sx={style}>
        <H3>
          <AccountBalanceOutlined
            fontSize="large"
            sx={{ verticalAlign: "bottom" }}
          />{" "}
          Cadastrar{" "}
        </H3>
        <Typography sx={{ marginTop: "20px", fontWeight: 700 }}>
          Importante:
        </Typography>
        <Typography>
          Somente cadastre uma nova Instituição/Cidade ou Unidade, se você
          realmente não a encontrou nos cadastros já existentes. E seu cadastros
          será submetido a aprovação de um administrador do LCE.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
          <Grid item xs={12}>
            <Formik
              onSubmit={handleFormSubmit}
              initialValues={initialValues}
              validationSchema={validationSchema}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      inputProps={{ readOnly: institution }}
                      name="code"
                      id="outlined-required"
                      label="Sigla Instituição"
                      size="small"
                      onBlur={handleBlur}
                      value={values.code}
                      onChange={handleChange}
                      helperText={touched.code && (errors.code as string)}
                      error={Boolean(touched.code && errors.code)}
                    />
                    <p></p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      inputProps={{ readOnly: institution }}
                      name="institution"
                      id="outlined-required"
                      label="Digite o nome da Instituição"
                      size="small"
                      onBlur={handleBlur}
                      value={values.institution}
                      onChange={handleChange}
                      helperText={
                        touched.institution && (errors.institution as string)
                      }
                      error={Boolean(touched.institution && errors.institution)}
                    />
                    <p></p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      inputProps={{ readOnly: division }}
                      name="unit"
                      id="outlined-required"
                      label="Digite o nome da Cidade"
                      size="small"
                      onBlur={handleBlur}
                      value={values.unit}
                      onChange={handleChange}
                      helperText={touched.unit && (errors.unit as string)}
                      error={Boolean(touched.unit && errors.unit)}
                    />
                    <p></p>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      name="department"
                      id="outlined-required"
                      label="Digite o nome da Unidade (Instituto/Departamento/Centro)"
                      size="small"
                      onBlur={handleBlur}
                      value={values.department}
                      onChange={handleChange}
                      helperText={touched.department && errors.department}
                      error={Boolean(touched.department && errors.department)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    &nbsp;
                  </Grid>
                  <div style={{ textAlign: "right" }}>
                    <LoadingButton
                      fullWidth
                      type="submit"
                      color="primary"
                      loading={loading}
                      variant="contained"
                      sx={{ mb: 2, mt: 1 }}
                      endIcon={<ArrowRightAltOutlined fontSize="small" />}
                    >
                      Solicitar Cadastro
                    </LoadingButton>
                  </div>
                </form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default FormInstitutionRequest;
